const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.598 392.598",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M359.855,21.786H32.743c-6.012,0-10.925,4.848-10.925,10.925v327.111 c0,6.012,4.848,10.925,10.925,10.925h327.111c6.012,0,10.925-4.848,10.925-10.925V32.711 C370.78,26.699,365.867,21.786,359.855,21.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M207.224,77.705c0,6.012-4.848,10.925-10.925,10.925c-6.077,0-10.925-4.848-10.925-10.925V65.358 H65.455v119.919h12.347c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H65.455v119.919h119.919v-12.347 c0-6.012,4.848-10.925,10.925-10.925c6.012,0,10.925,4.848,10.925,10.925v12.347h119.919V207.192h-12.348 c-6.012,0-10.925-4.848-10.925-10.925s4.848-10.925,10.925-10.925h12.348V65.422H207.224V77.705z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M359.855,0H32.743C14.707,0,0.032,14.675,0.032,32.711v327.111 c0,18.101,14.675,32.776,32.711,32.776h327.111c18.036,0,32.711-14.675,32.711-32.711V32.711C392.566,14.675,377.891,0,359.855,0z  M359.855,370.747H32.743c-6.012,0-10.925-4.848-10.925-10.925V32.711c0-6.012,4.848-10.925,10.925-10.925h327.111 c6.012,0,10.925,4.848,10.925,10.925v327.111h0.065C370.78,365.899,365.931,370.747,359.855,370.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M338.004,43.572H54.594c-6.012,0-10.925,4.848-10.925,10.925v283.539 c0,6.012,4.848,10.925,10.925,10.925h283.539c6.012,0,10.925-4.848,10.925-10.925V54.562 C348.994,48.549,344.016,43.572,338.004,43.572z M327.143,185.341h-12.347c-6.012,0-10.925,4.848-10.925,10.925 s4.848,10.925,10.925,10.925h12.347v119.919H207.224v-12.347c0-6.012-4.848-10.925-10.925-10.925 c-6.012,0-10.925,4.848-10.925,10.925v12.347H65.455V207.192h12.347c6.012,0,10.925-4.848,10.925-10.925 c0-6.012-4.848-10.925-10.925-10.925H65.455V65.422h119.919V77.77c0,6.012,4.848,10.925,10.925,10.925s10.925-4.848,10.925-10.925 V65.422h119.919V185.341L327.143,185.341z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.01,
    y: 100.978,
    style: {
      fill: "none"
    },
    width: 190.642,
    height: 190.642
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M214.659,262.982H177.81c-6.012,0-10.925,4.849-10.925,10.925s4.848,10.925,10.925,10.925h36.848 c6.012,0,10.925-4.848,10.925-10.925C225.648,267.83,220.735,262.982,214.659,262.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A3BF5"
    },
    d: "M249.697,185.341h-42.473v-65.422c0-6.012-4.848-10.925-10.925-10.925 c-6.077,0-10.925,4.848-10.925,10.925v76.347c0,6.012,4.848,10.925,10.925,10.925h53.398c6.012,0,10.925-4.848,10.925-10.925 S255.709,185.341,249.697,185.341z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.865e6dd92d388d6b1ac9a1c6faf2cd7b.svg";
export { ForwardRef as ReactComponent };